import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import { LogService } from '../../../services/shared/log.service';
import { NGaugeService } from '../../../services/shared/ngauge.service';
import { PubSubService } from '../../../services/shared/pub-sub.service';
import { TechService } from '../../../services/tech.service';
import { UserService } from '../../../services/user.service';
import { ShowGradeComponent } from '../../../shared-components/show-grade/show-grade.component';
import { ADD_PAGE, CORPORATE, EDIT_PAGE, LOG_LEVELS, LOG_MESSAGES, PLUS_CLICK, TEXT_AREA_TOOL_TIP, VIEW_PAGE } from '../../../util/constants';
import { AuthService } from '../../../services/shared/auth.service';

@Component({
  selector: 'app-suggest-enhancement',
  templateUrl: './suggest-enhancement.component.html',
  styleUrls: ['./suggest-enhancement.component.scss']
})
export class SuggestEnhancementComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('suggestSort') suggestSort: MatSort;
  @Input() editValue;
  panelOpenState1: any;
  panelOpenState2: any;
  dataSource: MatTableDataSource<any>;
  displayColumns = ['Title', 'Status', 'Action'];
  suggestionForm: FormGroup;
  statusValues = ['New', 'Submitted', 'Completed'];
  priorities = ['High', 'Medium', 'Low'];
  selectedIndex = 0;
  tabTitle = '';
  viewMode = '';
  propertySuggestId: any;
  saveClicked = false;
  suggest: any;
  isLoading = true;
  statusDescription = '';
  filteredStatus: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  statusFilterCtrl: FormControl = new FormControl();
  textToolTip = TEXT_AREA_TOOL_TIP;

  saveSuggestionSubscription: Subscription;
  getSuggestionSubscription: Subscription;
  getReportSuggestByIdSubscription: Subscription;
  dialogCloseSubscription: Subscription;
  updateGradeSubscription: Subscription;
  is_a_superadmin:boolean=false;
  constructor(
    private ngaugeService: NGaugeService,
    private formBuilder: FormBuilder,
    private pubSubService: PubSubService,
    private logService: LogService,
    private dialog: MatDialog,
    private userService: UserService,
    private authservice:AuthService,
    private techService: TechService) {
    this.logUserActivity('Suggest Enhancement', LOG_MESSAGES.CLICK);
    this.is_superadmin();

  }

  ngOnInit() {
    this.buildStatusDropdown();
    this.suggestionForm = this.buildForm();
    this.tabTitle = '';
  }

  ngAfterViewInit() {
    if (this.ngaugeService.checkForNllUndef(this.editValue)) {
      this.saveClicked = false;
      this.propertySuggestId = Number(this.editValue['value']);
      this.getReportSuggestByIdSubscription = this.techService.getSuggestByPropertyId(this.propertySuggestId,
        this.editValue['property']).subscribe(response => {
          this.statusValues = ['New', 'Submitted', 'Accepted', 'Rejected', 'Expired', 'Assigned', 'In-progress', 'Completed'];
          this.buildStatusDropdown();
          if (this.editValue['view'] === EDIT_PAGE) {
            this.suggestionForm.get('statusDescription').setValidators([Validators.required, Validators.maxLength(512)]);
            this.suggestionForm.get('taskPriority').setValidators(Validators.required);
            this.editIssue(response[0]);
          } else {
            this.viewIssue(response[0]);
          }
          this.getReportSuggestByIdSubscription.unsubscribe();
        }, error => {
          this.logService.logError(LOG_LEVELS.ERROR, 'Suggest Enhancement', 'On Fetch Suggest Enhancement By Id', JSON.stringify(error));
        });
    }
    this.getSuggestions();
  }

  getSuggestions() {
    this.dataSource = new MatTableDataSource([]);
    const params = this.techService.getFilterParams('updatedOn');
    this.getSuggestionSubscription = this.techService.getSuggestEnhancements(params).subscribe(data => {
      this.setDataSource(data, this.paginator, this.suggestSort);
      this.getSuggestionSubscription.unsubscribe();
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Suggestion Enhancement', 'On fetch suggest enhancements', JSON.stringify(error));
    });
  }

  setDataSource(data: any, paginator: MatPaginator, sort: MatSort) {
    this.dataSource = this.techService.getMatTable(data, paginator, sort);
    this.isLoading = false;
  }

  buildStatusDropdown() {
    this.ngaugeService.buildFilter(this.statusFilterCtrl, this.filteredStatus, this.statusValues, '');
  }

  addReportIssue() {
    this.saveClicked = false;
    this.viewMode = ADD_PAGE;
    this.statusDescription = '';
    this.tabTitle = this.viewMode + ' Suggestion Enhancement';
    this.suggestionForm = this.buildForm();
    this.suggestionForm.get('status').patchValue('New');
    this.selectedIndex = 1;
    this.logUserActivity('Suggestion Enhancement', PLUS_CLICK);
    setTimeout(() => {
      this.suggestionForm.get('statusDescription').setErrors(null);
    }, 200);
  }

  changeTabs(tabName) {
    this.logUserActivity('Suggestion Enhancement', tabName);
    if (tabName === 'Suggest') {
      this.selectedIndex = 0;
      this.getSuggestions();
    }
    this.logUserActivity('Suggestion Enhancement', tabName);
  }

  buildForm() {
    return this.formBuilder.group({
      about: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      describe: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      explain: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      status: ['', Validators.required],
      statusDescription: ['', Validators.maxLength(512)],
      taskPriority: ['']
    });
  }

  editIssue(issue) {
    if (this.ngaugeService.checkForNllUndef(issue['propertysuggestId'])) {
      this.propertySuggestId = Number(issue['propertysuggestId']);
    }
    this.suggest = issue;
    this.saveClicked = false;
    this.viewMode = EDIT_PAGE;
    this.statusDescription=issue.statusDescription;
    this.suggestionForm.addControl('property', new FormControl(issue.property));
    this.suggestionForm.addControl('SID', new FormControl(issue.SID));
    this.tabTitle = this.viewMode + ' Suggestion Enhancement';
    this.formatView(issue);
    this.logUserActivity('Suggestion Enhancement - Edit', issue.about);
  }

  formatView(issue) {
    this.suggestionForm.addControl('id', new FormControl(issue.id));
    this.suggestionForm.patchValue(issue);
    this.selectedIndex = 1;
    const propertyType = this.userService.getLoggedInPropertyType();
    if (propertyType !== CORPORATE && issue['status'] !== 'Submitted') {
      this.viewMode = '';
    }
    this.isLoading = false;
  }

  viewIssue(issue) {  
    this.viewMode = VIEW_PAGE;
    this.tabTitle = this.viewMode + ' Suggestion Enhancement';
    this.formatView(issue);
    this.logUserActivity('Suggestion Enhancement - View', issue.about);
  }

  getSuggestEnhancement(id, viewType) { 
    this.getReportSuggestByIdSubscription = this.techService.getSuggestById(id).
      subscribe(response => {
        this.statusDescription = response[0]['statusDescription'];
        switch (viewType) {
          case 'edit': this.editIssue(response[0]); break;
          case 'view': this.viewIssue(response[0]); break;
          case 'grade': this.updateGrade(response[0]); break;
        }
      });
  }

  save(value) {
    this.saveClicked = true;
    this.logUserActivity('Suggestion Enhancement - Save', LOG_MESSAGES.CLICK);
    if (this.suggestionForm.dirty) {
      if (this.viewMode === ADD_PAGE) {
        value['id'] = 0;
        value['createdBy'] = this.userService.getLoggedInUserId();
        value['property'] = this.userService.getLoggedInUserProperty();
        value['createdName'] = this.userService.getLoggedInUserName();
      }
      this.saveSuggestion(value);
    } else {
      this.selectedIndex = 0;
      this.tabTitle = '';
    }
  }

  saveSuggestion(value) {
    if (this.viewMode === EDIT_PAGE) {
      value['createdBy'] = this.suggest['createdBy'];
      value['updated'] = this.userService.getLoggedInUserId();
    }
    value['updatedOn'] = new Date();
    if (this.ngaugeService.checkForNllUndef(this.propertySuggestId)) {
      value['propertysuggestId'] = this.propertySuggestId;
    }
    if (value.status === 'New') {
      value['status'] = 'Submitted';
    }
    const propertyType = this.userService.getLoggedInPropertyType();
    value['iscorporate'] = propertyType === CORPORATE ? true : false;
    this.saveSuggestionSubscription = this.techService.saveSuggestEnhancement(value).subscribe(data => {
      if (data['result']) {
        const action = this.viewMode === ADD_PAGE ? 'created' : 'updated';
        this.ngaugeService.toastrSuccess('Suggest enhancement ' + action + ' successfully');
        this.tabTitle = '';
        this.selectedIndex = 0;
        const currentUrl = this.ngaugeService.getCurrentUrl();
        if (currentUrl.includes('helpCenter')) {
          this.pubSubService.publish('help-center-modified');
        }
        this.logUserActivity('Suggestion Enhancement - Save', LOG_MESSAGES.SUCCESS);
      } else {
        this.saveClicked = false;
        const action = this.viewMode === ADD_PAGE ? 'create' : 'update';
        this.ngaugeService.toastrError('Suggest enhancement ' + action + ' failed');
        this.logUserActivity('Suggestion Enhancement - Save', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Suggestion Enhancement', 'On Add/Edit Suggestion', JSON.stringify(value));
      }
    }, error => {
      this.saveClicked = false;
      this.logService.logError(LOG_LEVELS.DEBUG, 'Suggestion Enhancement', 'On Add/Edit Suggestion', JSON.stringify(error));
    });
  }

  updateGrade(issue) {
    this.logUserActivity('Suggest Enhancement - Grade', LOG_MESSAGES.CLICK);
    if(issue.SourceID != this.authservice.getSID()){
      this.ngaugeService.toastrError('You cannot grade this Suggestion');
        this.logUserActivity('Suggestion Enhancement- Grade', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Suggest enhancement', 'On Add/Edit of suggest enhancement', JSON.stringify(issue));
        return
    }
    const dialogRef = this.techService.openGradeComponent(issue);
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(result => {
      issue = this.techService.getMoreAttributes(issue, result);
      this.updateGradeSubscription = this.techService.saveSuggestEnhancement(issue).subscribe(() => {
        this.logUserActivity('Suggest Enhancement - Grade - Ok', LOG_MESSAGES.CLICK);
        this.ngaugeService.toastrSuccess('Suggestion Updated Successfully');
        setTimeout(() => {
          this.techService.publishCloseSideNavTriggerer('close');
        }, 100);
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Suggest Enhancement', 'On update grade', JSON.stringify(error));
      });
    });
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  closeSuggestEnhancement() {
    this.techService.publishCloseSideNavTriggerer('close');
    this.logUserActivity('Suggest Enhancement', LOG_MESSAGES.CANCEL);
  }

  pasteClipboardContent(fieldName, placeHolder) {
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Ask Question - ' + action, 'Paste ' + placeHolder);
    let preValue = this.suggestionForm.get(fieldName).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this.suggestionForm.get(fieldName).patchValue(preValue + text);
    });
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.saveSuggestionSubscription);
    this.unSubscribe(this.getSuggestionSubscription);
    this.unSubscribe(this.getReportSuggestByIdSubscription);
    this.unSubscribe(this.dialogCloseSubscription);
    this.unSubscribe(this.updateGradeSubscription);
    this.paginator = null;
    this.suggestSort = null;
    this.panelOpenState1 = null;
    this.panelOpenState2 = null;
    this.dataSource = null;
    this.displayColumns = null;
    this.suggestionForm = null;
    this.statusValues = null;
    this.priorities = null;
    this.selectedIndex = null;
    this.tabTitle = null;
    this.viewMode = null;
    this.suggest = null;
    this.isLoading = null;
    this.saveClicked = null;
    this.propertySuggestId = null;
    this.ngaugeService = null;
    this.formBuilder = null;
    this.pubSubService = null;
    this.logService = null;
    this.dialog = null;
    this.userService = null;
    this.techService = null;
    this.filteredStatus = null;
    this.statusFilterCtrl = null;
    this.textToolTip = null;
  }

  checksaveconditions(){ //if the ask is new no condition to save if not only ansering person(superadmin from ymc can save)
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if((this.viewMode==='Add'|| this.viewMode==='Edit') && (this.statusDescription===''|| (this.suggest.status !=="InProgress" || this.suggest.status !=="Resolved"))){
      if(this.viewMode==='Add'){
        return true
      }
      else{
        if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
          return true
        }
        else{
          return false
        }
  
      }
    }
    else{
      return false
    }
   
   
  }
  is_superadmin(){
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
      this.is_a_superadmin=true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/tech-support/suggest-enhancement/suggest-enhancement.component.ts